import Download from '@uhg-uicl/ui-core/dist/Download';
import Trash from '@uhg-uicl/ui-core/dist/Trash';
import { GridCell } from '@uhg-uicl/ui-core/dist';
import { AppealSearchRequest, AppealsHeaderData, AppealsInitialState } from './types';
import { AppealWorkQueueTypes } from './enum';

export const APPEAL_VALIDATION_ERROR_MSG = `Invalid search text, Allowed special characters: - _ .`;
export const APEAL_ID_SEARCH_INPUT_PLACEHOLDER = 'Search by Appeal ID';
export const CLAIM_ID_SEARCH_INPUT_PLACEHOLDER = 'Search by Claim ID';

export enum ActionTypesAppeal {
  SEACH_APPEAL_OR_CLIENT_ID = 'SEACH_APPEAL_OR_CLIENT_ID',
  SET_APPEALS_SEARCH_ID = 'SET_APPEALS_SEARCH_ID',
  SET_APPEALS_SEARCH_TYPE = 'SET_APPEALS_SEARCH_TYPE',
  SET_APPEALS_SEARCH_GRID = 'SET_APPEALS_SEARCH_GRID',
  TOGGLE_SHOW_APPEALS_SEARCH_GRID = 'TOGGLE_SHOW_APPEALS_SEARCH_GRID',
  TOGGLE_APPEALS_LOADING = 'TOGGLE_APPEALS_LOADING',
  SET_APPEALS_WORK_QUEUE_TITLE = 'SET_APPEALS_WORK_QUEUE_TITLE',
  SET_APPEALS_WORK_QUEUE_GRID = 'SET_APPEALS_WORK_QUEUE_GRID',
  TOGGLE_APPEALS_WORK_QUEUE_GRID_LOADING = 'TOGGLE_APPEALS_WORK_QUEUE_GRID_LOADING',
  TOGGLE_APPEALS_NAV_QUEUE_LOADING = 'TOGGLE_APPEALS_NAV_QUEUE_LOADING',
  SET_APPEALS_WORK_QUEUE_CPIDS = 'SET_APPEALS_WORK_QUEUE_CPIDS',
  SET_APPEALS_WORK_QUEUE_SERVICE_IDS = 'SET_APPEALS_WORK_QUEUE_SERVICE_IDS',
  SET_APPEALS_WORK_QUEUE_GRID_FILTER = 'SET_APPEALS_WORK_QUEUE_GRID_FILTER',
  SET_CLIENT_QUEUE_SELECTED_IDS = 'SET_CLIENT_QUEUE_SELECTED_IDS',
  SET_CLIENT_QUEUE_OPEN_GROUP_IDS = 'SET_CLIENT_QUEUE_OPEN_GROUP_IDS',
  SET_APPEALS_CLIENTS_BY_STATUS = 'SET_APPEALS_CLIENTS_BY_STATUS',
  SET_APPEALS_SERVICES_BY_STATUS = 'SET_APPEALS_SERVICES_BY_STATUS',
  TOGGLE_APPEALS_HEADER_LOADING = 'TOGGLE_APPEALS_HEADER_LOADING',
  SET_APPEALS_HEADER_DATA = 'SET_APPEALS_HEADER_DATA',
  TOGGLE_RECONSIDERATION_LOADING = 'TOGGLE_RECONSIDERATION_LOADING',
  SET_RECONSIDERATION_DATA = 'SET_RECONSIDERATION_DATA',
  SET_RECONSIDERATION_DROPDOWNS = 'SET_RECONSIDERATION_DROPDOWNS',
  SET_APPEALS_ADVANCED_SEARCH_PARAMS = 'SET_APPEALS_ADVANCED_SEARCH_PARAMS',
  TOGGLE_APPEALS_ADVANCED_SEARCH_LOOPKUP_LOADING = 'TOGGLE_APPEALS_ADVANCED_SEARCH_LOOPKUP_LOADING',
  TOGGLE_APPEALS_ADVANCED_SEARCH_LOADING = 'TOGGLE_APPEALS_ADVANCED_SEARCH_LOADING',
  SET_APPEALS_ADVANCED_SEARCH_LOOPKUP_DATA = 'SET_APPEALS_ADVANCED_SEARCH_LOOPKUP_DATA',
  SET_APPEAL_NOTES_DATA = 'SET_APPEAL_NOTES_DATA',
  SET_APPEALS_ADVANCED_SEARCH_CLIENT_DIVISION_DROPDOWN_DATA = 'SET_APPEALS_ADVANCED_SEARCH_CLIENT_DIVISION_DROPDOWN_DATA',
  CLEAR_APPEALS_DETAIL_PANE_REDUX_DATA = 'CLEAR_APPEALS_DETAIL_PANE_REDUX_DATA',
  CLEAR_APPEALS_SEARCH_PANE_REDUX_DATA = 'CLEAR_APPEALS_SEARCH_PANE_REDUX_DATA',
  TOGGLE_APPEAL_ATTACHMENTS_LOADING = 'TOGGLE_APPEAL_ATTACHMENTS_LOADING',
  TOGGLE_RECONSIDERATION_DROPDOWNS_LOADING = 'TOGGLE_RECONSIDERATION_DROPDOWNS_LOADING',
  SET_APPEALS_ATTACHMENT_INFO_DATA = 'SET_APPEALS_ATTACHMENT_INFO_DATA',
  TOGGLE_DETAIL_PANE_LOADING = 'TOGGLE_DETAIL_PANE_LOADING',
  TOGGLE_APPEAL_NOTES_LOADING = 'TOGGLE_APPEAL_NOTES_LOADING',
  TOGGLE_APPEAL_DOCUMENT_TYPE_LOADING = 'TOGGLE_APPEAL_DOCUMENT_TYPE_LOADING',
  TOGGLE_UPDATE_APPEAL_DOC_TYPE_LOADING = 'TOGGLE_UPDATE_APPEAL_DOC_TYPE_LOADING',
  SET_APPEAL_DOCUMENT_TYPE_DATA = 'SET_APPEAL_DOCUMENT_TYPE_DATA',
  SET_ALL_APPEAL_RECONSIDERATIONS = 'SET_ALL_APPEAL_RECONSIDERATIONS',
  TOGGLE_IS_ALL_APPEAL_RECONSIDERATION_LOADING = 'TOGGLE_IS_ALL_APPEAL_RECONSIDERATION_LOADING',
  TOGGLE_EXPORT_APPEAL_ADVANCED_SEARCH_LOADING = 'TOGGLE_EXPORT_APPEAL_ADVANCED_SEARCH_LOADING',
  TOGGLE_IS_UPDATE_ASSIGNEE_LOADING = 'TOGGLE_IS_UPDATE_ASSIGNEE_LOADING',
  TOGGLE_IS_ADD_ASSIGNEE_LOADING = 'TOGGLE_IS_ADD_ASSIGNEE_LOADING',
  TOGGLE_APPEAL_ACTIVITY_INFO_LOADING = 'TOGGLE_APPEAL_ACTIVITY_INFO_LOADING',
  SET_APPEAL_ACTIVITY_INFO_DATA = 'SET_APPEAL_ACTIVITY_INFO_DATA',
  SET_APPEAL_GRID_COLUMN_CONFIG = 'SET_APPEAL_GRID_COLUMN_CONFIG',
}
export const APPEALS_LOOKUP_SEARCH_TYPE = {
  APPEAL_ID: 'appealId',
  CLAIM_ID: 'claimId',
};
export const APPEAL_SEARCH_GRID_TITLE = 'Search Results';
export const APPEAL_EMPTY_GRID_RECORD_MESSAGE = 'No records to display at this time.';
//Appeal status
export const appealStatus = {
  Open: 1,
  Hold: 2,
  Closed: 3,
  Reopen: 4,
  Pend: 5,
  Canceled: 6,
};
export const APPEAL_SEARCH_RESULT_GRID_COLUMNS = new Set([
  {
    dataName: 'clientName',
    text: 'Client Name',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
  },
  {
    dataName: 'divisionName',
    text: 'Client Division',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
  },
  {
    dataName: 'appealId',
    text: 'Appeal ID',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
  },
  {
    dataName: 'statusChip',
    text: 'Appeal Status',
    sortable: true,
    isSorted: 0,
    cellType: 'chip',
    minWidth: '130px',
  },
  {
    dataName: 'appealLevel',
    text: 'Appeal Level',
    sortable: true,
    isSorted: 0,
    minWidth: '130px',
  },
  {
    dataName: 'submitDate',
    text: 'Create Date',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
    cellType: 'custom',
  },
  {
    dataName: 'claimId',
    text: 'Claim ID',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
  },
  {
    dataName: 'clientClaimId',
    text: 'Client Claim ID',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
  },
  {
    dataName: 'providerName',
    text: 'Provider Name',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
  },
  {
    dataName: 'patientName',
    text: 'Patient Name',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
  },
  {
    dataName: 'networkName',
    text: 'Network Partners',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
  },
  {
    dataName: 'reviewCode',
    text: 'Review Code',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
  },
  {
    dataName: 'service',
    text: 'Service',
    sortable: true,
    isSorted: 0,
    minWidth: '100px',
  },
  {
    dataName: 'submitter',
    text: 'Created By',
    sortable: true,
    isSorted: 0,
    minWidth: '180px',
  },
  {
    dataName: 'assignedToList',
    text: 'Assigned To',
    sortable: true,
    isSorted: 0,
    minWidth: '250px',
    cellType: 'custom',
  },
  {
    dataName: 'completeBy',
    text: 'Closed By',
    sortable: true,
    isSorted: 0,
    minWidth: '180px',
  },
]);

export const APPEAL_SEARCH_DEFAULT_COLUMNS = new Set([
  'clientName',
  'divisionName',
  'appealId',
  'statusChip',
  'appealLevel',
  'submitDate',
  'claimId',
  'clientClaimId',
  'providerName',
  'patientName',
  'networkName',
  'reviewCode',
  'service',
  'submitter',
  'assignedToList',
  'completeBy',
]);

export const RECONSIDERATION_GRID_COLUMNS = new Set([
  {
    dataName: 'appeal',
    text: 'Appealed',
    sortable: true,
    isSorted: 0,
    maxWidth: '120px',
    minWidth: '120px',
    cellType: 'custom',
    align: 'center',
  },
  {
    dataName: 'lineNum',
    text: 'Line',
    sortable: true,
    isSorted: 0,
    maxWidth: '80px',
    minWidth: '80px',
  },
  { dataName: 'dosBegin', text: 'DOS Begin', sortable: true, isSorted: 0, minWidth: '120px' },
  { dataName: 'dosEnd', text: 'DOS End', sortable: true, isSorted: 0, minWidth: '120px' },
  { dataName: 'reviewCode', text: 'Review Code', sortable: true, isSorted: 0, minWidth: '150px' },
  {
    dataName: 'expCode',
    text: 'Exp Code',
    sortable: true,
    isSorted: 0,
    minWidth: '120px',
    cellType: 'custom',
  },
  { dataName: 'recommend', text: 'Recommend', sortable: true, isSorted: 0, minWidth: '150px' },
  {
    dataName: 'response',
    text: 'Response',
    sortable: true,
    isSorted: 0,
    minWidth: '250px',
    cellType: 'custom',
  },
  {
    dataName: 'responseDescription',
    text: 'Response Description',
    sortable: true,
    isSorted: 0,
    minWidth: '270px',
    cellType: 'custom',
  },
  {
    dataName: 'billedCharge',
    text: 'Billed Charges',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
    align: 'right',
  },
  {
    dataName: 'allowed',
    text: 'Allowed',
    sortable: true,
    isSorted: 0,
    minWidth: '100px',
    align: 'right',
  },
  {
    dataName: 'savings',
    text: 'Savings',
    sortable: true,
    isSorted: 0,
    minWidth: '100px',
    align: 'right',
  },
  {
    dataName: 'recAmount',
    text: 'Rec. Amount',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
    align: 'right',
  },
  { dataName: 'serviceCategory', text: 'Service', sortable: true, isSorted: 0, minWidth: '120px' },
  {
    dataName: 'eorNotes',
    text: 'EOR Notes',
    sortable: true,
    isSorted: 0,
    minWidth: '500px',
    cellType: 'custom',
  },
]);
export const RECONSIDERATION_MODAL_GRID_COLUMNS = new Set([
  {
    dataName: 'appeal',
    text: 'Appealed',
    sortable: true,
    isSorted: 0,
    maxWidth: '120px',
    minWidth: '120px',
    cellType: 'custom',
    align: 'center',
  },
  {
    dataName: 'lineNum',
    text: 'Line',
    sortable: true,
    isSorted: 0,
    maxWidth: '95px',
    minWidth: '95px',
  },
  { dataName: 'dosBegin', text: 'DOS Begin', sortable: true, isSorted: 0, minWidth: '120px' },
  { dataName: 'dosEnd', text: 'DOS End', sortable: true, isSorted: 0, minWidth: '120px' },
  { dataName: 'reviewCode', text: 'Review Code', sortable: true, isSorted: 0, minWidth: '150px' },
  {
    dataName: 'expCode',
    text: 'Exp Code',
    sortable: true,
    isSorted: 0,
    minWidth: '120px',
  },
  {
    dataName: 'recommend',
    text: 'Recommend',
    sortable: true,
    isSorted: 0,
    minWidth: '240px',
    cellType: 'custom',
  },
  {
    dataName: 'response',
    text: 'Response',
    sortable: true,
    isSorted: 0,
    minWidth: '350px',
    cellType: 'custom',
  },
  {
    dataName: 'responseDescription',
    text: 'Response Description',
    sortable: true,
    isSorted: 0,
    minWidth: '270px',
    cellType: 'custom',
  },
  {
    dataName: 'billedCharge',
    text: 'Billed Charges',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
    align: 'right',
  },
  {
    dataName: 'allowed',
    text: 'Allowed',
    sortable: true,
    isSorted: 0,
    minWidth: '100px',
    align: 'right',
  },
  {
    dataName: 'savings',
    text: 'Savings',
    sortable: true,
    isSorted: 0,
    minWidth: '100px',
    align: 'right',
  },
  {
    dataName: 'recAmount',
    text: 'Rec. Amount',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
    align: 'right',
  },
  { dataName: 'serviceCategory', text: 'Service', sortable: true, isSorted: 0, minWidth: '120px' },
  {
    dataName: 'eorNotes',
    text: 'EOR Notes',
    sortable: true,
    isSorted: 0,
    minWidth: '500px',
    cellType: 'custom',
  },
]);
export const APPEAL_NOTES_GRID_COLUMNS = new Set([
  {
    dataName: 'modifiedOn',
    text: 'Date/Time',
    sortable: true,
    isSorted: 0,
  },
  {
    dataName: 'modifiedBy',
    text: 'User',
    sortable: true,
    isSorted: 0,
  },
  {
    dataName: 'note',
    text: 'Note',
    sortable: true,
    isSorted: 0,
  },
  {
    dataName: 'internalFlag',
    text: 'I/E',
    sortable: true,
    isSorted: 0,
    cellType: 'chip',
  },
  {
    dataName: 'trashIcon',
    text: <GridCell cellType="icon" data={{ icon: Trash }} />,
    sortable: true,
    isSorted: 0,
    cellType: 'custom',
  },
]);
export const AppealsDetailPaneInititalState: AppealsInitialState = {
  // navigation
  appealsSearchId: '',
  appealsSearchType: APPEALS_LOOKUP_SEARCH_TYPE.APPEAL_ID,
  isAppealsHeaderLoading: false,
  appealsHeaderData: {} as AppealsHeaderData,
  appealsAdvancedSearchParams: {} as AppealSearchRequest,
  appealsWorkQueueTitle: AppealWorkQueueTypes.all,
  appealsWorkQueueGridData: [],
  isAppealsWorkQueueGridLoading: false,
  isAppealsNavQueueLoading: false,
  appealsWorkQueueCpIDs: '',
  appealsWorkQueueServiceIDs: '',
  isAppealsWorkQueueGridFiltered: false,
  appealsQueueSelectedIds: new Set(),
  appealsQueueOpenGroupIds: new Set(),
  clientsByStatus: [],
  servicesByStatus: [],
  reconsiderationData: [],
  reconsiderationDropdowns: {
    appealRecommendations: [],
    appealResponses: [],
  },
  allAppealReconsiderations: {
    appealRecommendations: [],
    appealResponses: [],
    serviceCategories: [],
  },
  isAllAppealReconsiderationsLoading: false,
  isReconsiderationDropdownsLoading: false,
  appealNotesData: [],
  isReconsiderationLoading: false,
  isAppealsAttachmentInfoLaoding: false,
  appealsAttachmentInfoData: [],
  isDetailPaneLoading: false,
  isAppealNotesLoading: false,
  isAppealDocumentTypeLoading: false,
  appealDocumentTypeData: [],
  isUpdateAppealDocTypeLoading: false,
  isExportAppealAdvancedSearchLoading: false,
  isUpdateAssigneeLoading: false,
  isAddAssigneeLoading: false,
  isAppealActivityInfoLoading: false,
  appealActivityInfoData: [],
  appealGridColumnConfig: [],
};

export const APPEALS_ACTIONS_DROP_DOWN_MENU_ITEMS = [
  {
    id: 1,
    label: 'Add a Note',
  },
  {
    id: 2,
    label: 'Appeal Reconsideration',
  },
  {
    id: 3,
    label: 'Attach a Document',
  },
];

export const STANDARD_USER_APPEALS_ACTIONS_DROP_DOWN_MENU_ITEMS = [
  {
    id: 1,
    label: 'Add a Note',
  },
  {
    id: 3,
    label: 'Attach a Document',
  },
];

export const STANDARD_USER_APPEALS_ACTIONS_DROP_DOWN_MENU_WITHOUT_DOC_ITEMS = [
  {
    id: 1,
    label: 'Add a Note',
  },
];

export const APPEALS_ATTACHMENTS_GRID_COLUMNS = new Set([
  {
    dataName: 'modifiedBy',
    text: 'User',
    sortable: true,
    isSorted: 0,
    minWidth: '40px',
    align: 'left',
    cellType: 'custom',
  },
  {
    dataName: 'fileName',
    text: 'File Name',
    sortable: true,
    isSorted: 0,
    minWidth: '60px',
    align: 'left',
    cellType: 'custom',
  },
  {
    dataName: 'download',
    text: <GridCell cellType="icon" data={{ icon: Download }} />,
    minWidth: '30px',
    align: 'left',
    cellType: 'custom',
  },
  {
    dataName: 'modifiedDate',
    text: 'Date/Time',
    sortable: true,
    isSorted: 0,
    align: 'left',
    minWidth: '110px',
  },
  {
    dataName: 'internalFlag',
    text: 'I/E',
    sortable: true,
    isSorted: 0,
    align: 'left',
    minWidth: '110px',
    cellType: 'chip',
  },
  {
    dataName: 'trashIcon',
    text: <GridCell cellType="icon" data={{ icon: Trash }} />,
    sortable: true,
    isSorted: 0,
    cellType: 'custom',
    isHeaderTruncated: true,
    headerWidth: 50,
  },
]);

export const attachDocMessages = {
  attachDocument: 'Attach a Document',
  fileTypeError: 'Uploading of this file type is not allowed.',
  fileSizeError: 'File cannot exceed 100MB in size.',
  fileError: 'Please select a file.',
  enterANote: 'Enter a Note.',
  save: 'Save',
  cancel: 'Cancel',
  note: 'Note',
};

export const APPEAL_SERVICES = {
  irn: 'IRN',
  insightReview: 'Insight Review',
  codeEdit: 'Code Edit',
};

export const APPEAL_SERVICES_NO_IRN = ['Insight Review', 'Code Edit'];

export const APPEALS_DETAIL_PANE_GRID_COLUMNS = new Set([
  {
    dataName: 'appealLink',
    text: 'Appeal ID',
    sortable: false,
    isSorted: 0,
    minWidth: '160px',
    cellType: 'custom',
  },
  {
    dataName: 'statusChip',
    text: 'Appeal Status',
    sortable: false,
    isSorted: 0,
    minWidth: '160px',
    cellType: 'chip',
  },
  {
    dataName: 'submitDate',
    text: 'Create Date',
    sortable: false,
    isSorted: 0,
    minWidth: '160px',
  },
  {
    dataName: 'completeDate',
    text: 'Complete Date',
    sortable: false,
    isSorted: 0,
    minWidth: '160px',
  },
  {
    dataName: 'recommend',
    text: 'Recommend',
    sortable: false,
    isSorted: 0,
    minWidth: '170px',
  },
  {
    dataName: 'response',
    text: 'Response',
    sortable: false,
    isSorted: 0,
    minWidth: '170px',
  },
  {
    dataName: 'appealReason',
    text: 'Reason for Appeal',
    sortable: false,
    isSorted: 0,
    minWidth: '160px',
  },
  {
    dataName: 'submitterName',
    text: 'Created By',
    sortable: false,
    isSorted: 0,
    minWidth: '160px',
  },
  {
    dataName: 'submitterEmail',
    text: 'Email Address',
    sortable: false,
    isSorted: 0,
    minWidth: '160px',
  },
  {
    dataName: 'completeBy',
    text: 'Closed By',
    sortable: false,
    isSorted: 0,
    minWidth: '160px',
  },
]);
export const APPEAL_SERVICES_ALL = ['Insight Review', 'Code Edit', 'IRN'];

export const APPEAL_ACTIVITY_GRID_COLUMNS = new Set([
  {
    dataName: 'userName',
    text: 'User',
    sortable: true,
    isSorted: 0,
    headerWidth: 150,
    isHeaderTruncated: true,
  },
  {
    dataName: 'activity',
    text: 'Activity',
    sortable: true,
    isSorted: 0,
    headerWidth: 150,
    isHeaderTruncated: true,
  },
  {
    dataName: 'description',
    text: 'Description',
    sortable: true,
    isSorted: 0,
    headerWidth: 220,
    isHeaderTruncated: true,
    cellType: 'custom',
  },
  {
    dataName: 'dateTime',
    text: 'Date/Time',
    sortable: true,
    isSorted: 0,
    headerWidth: 150,
    isHeaderTruncated: true,
  },
]);
